import type { FC } from "react";
import { styled } from "@linaria/react";
import { HumanFriendlyStringDate } from "@/helpers/date.ts";
import type { FlowItem } from "@/types/flow.ts";

const Pill = styled.div`
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 1.5rem;
  background-color: #adeed3;
  color: #111;
  text-align: center;
  max-width: 100%;
  span {
    font-size: var(--13px);
    font-weight: 600;
  }

  justify-self: center;
  align-self: center;
`;

interface FlowMessageInformationProps {
  flowItem: Partial<FlowItem>;
}

export const FlowMessageInformation: FC<FlowMessageInformationProps> = ({ flowItem }) => {
  if (!flowItem.text) return null;
  const lines = flowItem.text.split("\n");
  return (
    <Pill
      data-tooltip={"Dispatched at: " + HumanFriendlyStringDate(flowItem.dateDispatched ?? "")}
      data-direction="top"
    >
      {lines.map((line, i) => (
        <span key={"flowmessageinformation" + line}>
          {line}
          {i < lines.length - 1 && <br />}
        </span>
      ))}
    </Pill>
  );
};
